module.exports = __webpack_public_path__ + "03_medium_black.3bad426e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/03_medium_black.png
// module id = llga
// module chunks = 0